import { InputAdornment, TextField } from "@mui/material";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils/cn.utils";
import Button from "../button";

const InputClass = cva(`
    w-[100%] h-[52px]
    `);

interface InputProps {
    className?: string;
    label: string;
    buttonLabel?: string;
    placeholder?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => unknown;
    onKeyDown?: (event: React.KeyboardEvent) => unknown;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<InputProps> = ({
    className,
    label,
    buttonLabel,
    placeholder,
    onClick = () => null,
    onKeyDown,
    onChange,
}) => {
    return (
        <TextField
            className={cn(InputClass(), className)}
            label={label}
            placeholder={placeholder}
            onChange={onChange}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button
                                variant="primary"
                                onClick={onClick}
                                onKeyDown={onKeyDown}
                                label={buttonLabel || "검색"}
                            />
                        </InputAdornment>
                    ),
                },
                inputLabel: { shrink: true },
            }}
        />
    );
};

export default SearchInput;
